import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import {  Login, EsqueceuSenha, NovaSenha } from '../pages';
import { AuthenticatedArea, Header } from '../components';

const PUBLIC_PATHS = [
  { path: '/login', component: Login },
  { path: '/recuperar-senha/:hash', component: NovaSenha },
  { path: '/esqueci-minha-senha', component: EsqueceuSenha }
];

@inject('SiteStore', 'AuthenticationStore') @observer
export default class App extends Component {
  componentWillMount() {
    const { AuthenticationStore } = this.props;
    AuthenticationStore.validate();
  }

  render() {
    const { SiteStore, AuthenticationStore } = this.props;
    return (
      <div>
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
        { AuthenticationStore.isChecked &&
          <Route render={({ location }) => (
              <div>
                <Route exact path="/" render={() => (AuthenticationStore.isAuthenticated ? <Redirect to="/inicio"/> : null) } />

                  { AuthenticationStore.isAuthenticated && <AuthenticatedArea /> }


                  { PUBLIC_PATHS.map((item, index) => (
                    <Route key={`path-${index}`} { ...item } />
                  ))}

                  <Route render={({ location }) =>  {
                      const regexPaths = /\/downloads|\/recuperar-senha/;
                      if (PUBLIC_PATHS.find(i => i.path === location.pathname) ||
                      regexPaths.test(location.pathname) ||
                      AuthenticationStore.isAuthenticated) { return null; }
                      return <Redirect to="/login"/>
                    }} />

              </div>
            )} />
        }
        </Switch>
      </Router>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js